import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Button from '../../components/common/Button';
import LeftNavBar from '../../pages/AppWrapperViewComponent/LeftNavBar';
import BreadcrumbComponent from './../../components/common/Breadcrumb';
import { useLocation } from 'react-router-dom';
import Pencil from './../../assets/svg/pencil.svg';
import NationalEmblem from './../../assets/svg_main/national_emblem.svg';
import BackArrowsvg from './../../assets/svg_main/BackArrowIconSvg.svg';
import '../AppWrapperViewComponent/AppWrapperViewComponent.css';
import { useDispatch } from 'react-redux';
import { resetForm, updateForm } from '../../store/actions/userManagementAction';

import { ChildComponentHandlerUpdateUser } from '../AppWrapperViewComponent/OverView/UserManagementUpdate';
import { CommonHamburgar } from '@components/common/CommonHamburgar';
import PrivielegeDetails from './PrivielegeDetails';
interface RoleComponentProps {
    page: string;
    flow: string;
}

const RoleManagementView = (props: RoleComponentProps) => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const { page, flow } = props;
    const [roleDetails, setRoleDetails] = useState(JSON.parse(state));
    
    const [currentTab, setCurrentTab] = useState('Overview');
    const childRef = useRef<ChildComponentHandlerUpdateUser>();
    const tabs = ['Overview'];

    const buttonName = flow === 'viewRole' ? 'Edit Privileges' : 'Submit'
    const icon = buttonName === 'Edit Privileges' ? <Pencil /> : ''

    const updateHandlerUpdate = () => {
        
        if (childRef.current) {
            childRef.current.handleUpdateSave();
        }
    }
    const dispatch = useDispatch();

    const handleBack = () => {
        dispatch(resetForm());
    }

    const handleNavClick = (item: any) => {
        setCurrentTab(item);
    }

    return (
        <div className="app-view-wrapper">
            <header className="view-header">
                <div className="logo-wrapper">
                    <NationalEmblem className="logo" />
                    <div className="name-wrapper">
                        <div className="name-wrapper-title">
                            JANANI
                        </div>
                        <div className="name-wrapper-subtext">
                            Journey of Antenatal, Natal and Neonatal Integrated Care
                        </div>
                        <div className="name-wrapper-subtext" style={{ fontWeight: 'bold' }}>Sehat ke Sath, Every Step of Care</div>
                    </div>
                </div>
                <div className="view-route">
                    <BreadcrumbComponent
                        breadcrumbItemName={[
                            { value: page, label: 'User Management' },
                            { value: page, label: 'Role' },
                        ]}
                    />
                </div>
            </header>
            <main className="view-content">
                <div className="view-profile-buttons">
                    <div className="view-profile">
                        <CommonHamburgar>
                            <LeftNavBar
                                navItems={tabs}
                                currentTab={currentTab}
                                handleNavClick={setCurrentTab}
                            />
                        </CommonHamburgar>
                        <Link to={'/user-management/role'}>
                            <Button
                                onClick={handleBack}
                                disabled={false}
                                id=""
                                buttonName={''}
                                colorType={'verticalbackbutton'}
                                icon={<BackArrowsvg />}
                                iconPosition={'left'}
                            />
                        </Link>
                        <div className="name-type">
                            <div className="type">{roleDetails.user_type}</div>
                            <div className="name">{roleDetails.role_name}</div>
                        </div>
                    </div>
                    <div className="cancel-edit">
                        <Button
                            onClick={() => {
                                navigate('/user-management/role');
                            }}
                            disabled={false}
                            id="cancel"
                            buttonName={'Cancel'}
                            colorType={'save'}
                            icon={''}
                            iconPosition={'right'}

                        />
                        <Button
                            onClick={() => {
                                dispatch(updateForm("edit_privilege_flow", true))
                                flow === 'viewRole' ? navigate(`/user-management/role/edit/${roleDetails.role_id}`, {
                                    state: JSON.stringify(roleDetails),
                                }) : updateHandlerUpdate()
                            }}
                            disabled={false}
                            id={flow === 'view' ? 'edit-privileges' : 'save-details'}
                            buttonName={buttonName}
                            colorType={'primary'}
                            icon={icon}
                            iconPosition={'right'}
                        />
                    </div>
                </div>
                <div className="content">
                    <LeftNavBar
                        navItems={tabs}
                        currentTab={currentTab}
                        handleNavClick={handleNavClick}
                    />
                    <div className="tab-content">

                    <PrivielegeDetails flow={flow} page={page} roleDetails={roleDetails}/>
                    </div>
                </div>
            </main>
        </div>
    );
};
export default RoleManagementView;
